import { Component, OnInit, Input } from '@angular/core';

import {PlanoService} from "../../../planos/shared/plano.service";
import {UtilService} from "../../../../shared/services/util.service";
import {servicosStorage} from "../../shared/data.service";
import {planosStorage} from "../../../planos/shared/data.service";
import {AutoCompleteService} from "../../../../shared/components/autocomplete/autocomplete.service";

@Component({
    selector: 'app-servico-plano-form-list',
    template: require('./servico-plano-form-list.component.html'),
    styles: [require('./servico-plano-form-list.component.css')]
})
export class ServicoPlanoFormListComponent implements OnInit {
    @Input() planoObject: any = {};
    @Input() categoriaObject: any = {};
    @Input() marcaObject: any = {};
    @Input() servicoObject: any = {};
    @Input() list: any[] = [];

    constructor(
        private _planoService: PlanoService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService
    ) {}

    ngOnInit() {

    }

    clickRemove(item: any[]) {
        //item[0] = objeto de servico / item[1] = index na lista
        let onDelete = (function() {
            this.list.splice(item[1], 1);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete, true);
    }

    onSubmit(evt: any) {
        this.setNewList(evt);
    }

    getServicoObject(object: any) {
        let thisFormObject: any = this.planoObject;
        thisFormObject.categoria = this.categoriaObject;
        thisFormObject.marca = this.marcaObject;
        thisFormObject.servicos = this.list;

        this._planoService.setSessionStorage(thisFormObject);

        let toOtherFormObject: any = {
            descricao: object.text,
            form: planosStorage
        };
        this._autocompleteService.setSessionStorage(toOtherFormObject, servicosStorage);
    }

    private setNewList(object: any) {
        this.list.push(object);
        this.servicoObject = {};
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servico-planos/servico-plano-form-list/servico-plano-form-list.component.ts
 **/